import { useState, createContext, useContext } from "react";
import defaultPlaceholderImage from "../assets/headshot_gen_neutral.png";

export const MiscContext = createContext();

export const useMisc = () => {
    return useContext(MiscContext);
};

export const MiscProvider = ({ children }) => {
    const [theme, setTheme] = useState("dark");
    const [navTitle, setNavTitle] = useState("");
    const [myCache, setMyCache] = useState({});

    const toTitleCase = (str) => {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };

    const getViewLinkFromDriveLink = (driveLink) => {
        console.log("drive: " + driveLink);
        if (typeof driveLink == 'undefined' || !driveLink ) return defaultPlaceholderImage;

        const regex = /https:\/\/drive\.google\.com\/open\?id=(.*)/;

        const match = driveLink.match(regex);

        if (match && match[1]) {
            console.log("Match found: " + `https://drive.google.com/uc?id=${match[1]}` )
            return (`https://drive.google.com/uc?id=${match[1]}`);

        } else {
            console.log("Match not found.")
            return defaultPlaceholderImage;
        }
    };

    const readableError = (firebaseError) => {
        const errors = {
            "auth/invalid-credential": "Email Password combination is invalid.",
            "auth/invalid-email": "Invalid Email. Make sure the Email is complete with an @ sign.",
            "auth/internal-error": "Internal Error. Make sure your internet connection is stable.",
            "auth/popup-closed-by-user": "Sign In popup was closed. Make sure browser allows site to open popups and external links.",
            "auth/email-already-in-use": "Email is already in use. Try another email.",
            "auth/account-exists-with-different-credential": "You have an account with this email using a different sign-in method. Please use that method to sign in.",
        }

        return errors[firebaseError] || firebaseError;
    }

    const challengeNameToPageTitle = (challengeName) => {
        const words = challengeName.split(" ");
        const titleCaseWords = words.map((word) => {
            if (word.length >= 3) {
                return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
            } else {
                return word;
            }
        });
        const pageTitle = titleCaseWords.join(" ").replace(/\.$/, "");
        return pageTitle;
    };

    const convertSnakeTagsToTitle = (snakeTag) => {
        const words = snakeTag.split("_");
        const titleCaseWords = words.map((word) => {
            return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
        });
        const titleTag = titleCaseWords.join(" ").replace(/\.$/, "");
        return titleTag;
    }

    const value = {
        myCache,
        setMyCache,
        theme,
        setTheme,
        navTitle,
        setNavTitle,
        toTitleCase,
        getViewLinkFromDriveLink,
        readableError,
        challengeNameToPageTitle,
        convertSnakeTagsToTitle
    };

    return (
        <MiscContext.Provider value={value}>{children}</MiscContext.Provider>
    );
};
